import { useEffect, useState } from "react";
import CommonService from "../../services/common.service";

import moment from "moment";

const LeaveOverviewReport = ({
  details,
  leaveOverviewData,
  setLeaveOverviewData,
  filter,
  filteredData
}) => {
  const fetchData = () => {
    const payload = {
      empid: details.empId ? details.empId : null,
      fromdate: details.fromDate,
      todate: details.toDate,
    };

    CommonService.getLeaveOverViewReport(payload)
      .then((resp) => {
        if (resp.data) {
          setLeaveOverviewData(resp.data);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="leaveOverviewReport">
        <div className="table-responsive">
          <table
            className="table table-striped table-bordered"
            id="myTable2"
            border="1"
            cellspacing="0"
            cellpadding="8"
          >
            <tr>
              <td colSpan={6} style={{ textAlign: "center" }}>
                {`${moment(details.fromDate).format(
                  "MMM DD YYYY"
                )}  To  ${moment(details.toDate).format("MMM DD YYYY")}`}
              </td>
            </tr>
            {Array.isArray(filter ? filteredData : leaveOverviewData)
              ? (filter ? filteredData : leaveOverviewData).map((item) => {
                  return (
                    <>
                      <tr
                        style={{
                          borderTop: "2px solid rgba(189, 182, 201, 1)",
                          borderLeft: "2px solid rgba(189, 182, 201, 1)",
                          borderRight: "2px solid rgba(189, 182, 201, 1)",
                        }}
                      >
                        <td colSpan={2}>
                          <strong>Name :</strong> {item.empName}
                        </td>
                        <td colSpan={2}>
                          <strong>Id:</strong> {item.empCode}
                        </td>
                        <td colSpan={2}>
                          <strong>Location:</strong> {item.location}
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderLeft: "2px solid rgba(189, 182, 201, 1)",
                          borderRight: "2px solid rgba(189, 182, 201, 1)",
                        }}
                      >
                        <td colSpan={2}>
                          <strong>Joining Date: </strong> {item.joiningDAte}
                        </td>

                        <td colSpan={2}>
                          <strong>Confirmation Date: </strong>{" "}
                          {item.confirmDate}
                        </td>
                        <td colSpan={2}></td>
                      </tr>
                      <tr
                        style={{
                          borderLeft: "2px solid rgba(189, 182, 201, 1)",
                          borderRight: "2px solid rgba(189, 182, 201, 1)",
                        }}
                      >
                        <td colSpan={2}>
                          <span>
                            {" "}
                            <strong>Quarterly Allocated Leaves: </strong>{" "}
                            {item.qurterlyLeaves}
                          </span>
                        </td>

                        <td colSpan={2}>
                          <span>
                            {" "}
                            <strong>Yearly Allocated Leaves: </strong>{" "}
                            {item.allocatedLeaves}
                          </span>
                        </td>
                        <td colSpan={2}></td>
                      </tr>
                      <tr
                        className="header-row"
                        style={{
                          borderLeft: "2px solid rgba(189, 182, 201, 1)",
                          borderRight: "2px solid rgba(189, 182, 201, 1)",
                        }}
                      >
                        <th>Sr. No.</th>
                        <th>Date</th>
                        <th>Leave Type</th>
                        <th>Leave Category</th>
                        <th>Taken Leaves</th>
                        <th>Balance Leaves</th>
                      </tr>
                      {Array.isArray(item.empLeaveDay) &&
                      item.empLeaveDay.length > 0 ? (
                        item.empLeaveDay.map((data, index) => {
                          return (
                            <>
                              <tr
                                className="body-row"
                                style={{
                                  borderLeft:
                                    "2px solid rgba(189, 182, 201, 1)",
                                  borderRight:
                                    "2px solid rgba(189, 182, 201, 1)",
                                }}
                              >
                                <td>{index + 1}</td>
                                <td>{data.leaveDay}</td>
                                <td>{data.leaveType}</td>
                                <td>{data.leaveCategory}</td>
                                {index === 0 ? (
                                  <>
                                    <td
                                      rowSpan={item.empLeaveDay.length}
                                      style={{
                                        borderLeft:
                                          "1px solid rgba(189, 182, 201, 1)",
                                        borderRight:
                                          "1px solid rgba(189, 182, 201, 1)",
                                      }}
                                    >
                                      <div>Paid {data.paidLeave}</div>
                                      <div>Unpaid {data.unpaid}</div>
                                      <div>Goodwill {data.goodwill}</div>
                                    </td>
                                    <td rowSpan={item.empLeaveDay.length}>
                                      {data.balanceLeave}
                                    </td>
                                  </>
                                ) : null}
                              </tr>
                            </>
                          );
                        })
                      ) : (
                        <>
                          <tr
                            style={{
                              borderLeft: "2px solid rgba(189, 182, 201, 1)",
                              borderRight: "2px solid rgba(189, 182, 201, 1)",
                              borderBottom: "2px solid rgba(189, 182, 201, 1)",
                            }}
                          >
                            <td colSpan={6} style={{ textAlign: "center" }}>
                              No Leaves Taken
                            </td>
                          </tr>
                        </>
                      )}

                      <tr style={{ height: "20px" }}></tr>
                    </>
                  );
                })
              : null}
          </table>
        </div>
      </div>
    </>
  );
};

export default LeaveOverviewReport;
